import React from "react";
const ImagePopup = React.forwardRef((props, ref) => {
  const { showModalBox, title, description, isAdd, image } = props;

  const closePopupHandler = () => {
    props.closePopup();
  };

  const proceedHandler = (e) => {
    e.preventDefault();
    props.proceedHandler();
  };

  return (
    <>
      <>
        <div
          className={
            "cstm-popup-dialog " + (showModalBox === 1 ? "show" : "hidden")
          }
          onClick={closePopupHandler}
        >
          <div
            className="cstm-popup"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="cstm-popup-header">
              <h6 className="m-0">{title}</h6>
              <span
                className="cstm-popup-close-btn"
                onClick={closePopupHandler}
              >
                &times;
              </span>
            </div>
            <div className="cstm-popup-body p-3">
              <div className="d-flex flex-column align-items-center">
                <img
                  src={image}
                  className="img-fluid"
                  style={{ height: "300px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
});

export default ImagePopup;
